import { render, staticRenderFns } from "./Offboarding.vue?vue&type=template&id=dd0fca10"
import script from "./Offboarding.js?vue&type=script&lang=js&external"
export * from "./Offboarding.js?vue&type=script&lang=js&external"
import style0 from "./Offboarding.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports